import { useState } from "react";
import { Eye, EyeOff } from "lucide-react";
import { maskContactName } from "@/lib/utils";

/**
 * Reusable privacy-masked contact name display.
 * Shows masked last name by default with a toggle to reveal/hide.
 * Never modifies the database — purely presentational.
 */
export function MaskedContactName({
  name,
  className = "",
  showToggle = true,
}: {
  name: string | null | undefined;
  className?: string;
  showToggle?: boolean;
}) {
  const [revealed, setRevealed] = useState(false);
  const display = revealed ? (name?.trim() || "Unknown") : maskContactName(name);
  const hasLastName = (name?.trim().split(/\s+/).length ?? 0) > 1;

  return (
    <span className={`inline-flex items-center gap-1.5 ${className}`}>
      <span>{display}</span>
      {showToggle && hasLastName && (
        <button
          type="button"
          onClick={(e) => { e.stopPropagation(); setRevealed(!revealed); }}
          title={revealed ? "Hide name" : "Show full name"}
          className="inline-flex items-center justify-center w-4 h-4 rounded text-slate-400 hover:text-slate-600 transition flex-shrink-0"
        >
          {revealed ? <EyeOff className="w-3 h-3" /> : <Eye className="w-3 h-3" />}
        </button>
      )}
    </span>
  );
}
